import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_hint-pointer-down",
  "use": "svg_hint-pointer-down-usage",
  "viewBox": "0 0 14 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 18\" id=\"svg_hint-pointer-down\"><path d=\"m.85 8.396 4.237 2.138c.158.066.326.104.504.104H6.3v5.676c0 .785.625 1.42 1.4 1.42.775 0 1.4-.635 1.4-1.42V6.154l3.201.681c.075.01.14.029.224.029.29 0 .55-.123.738-.312L14 5.795 9.39 1.12A1.395 1.395 0 0 0 8.4.705H2.063c-.7 0-1.242.52-1.344 1.211l-.7 4.986A1.33 1.33 0 0 0 0 7.09c0 .586.355 1.097.85 1.305\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol